import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env, isSupabaseConfigured } from '@/config/env';
import type { Database } from './database.types';

/**
 * Client Supabase unique pour toute l'application.
 *
 * - Ne contient QUE la cle publique `anon`. La securite repose sur les policies
 *   RLS de la base, pas sur le secret de la cle.
 * - La session est persistee dans le `localStorage` et rafraichie automatiquement.
 * - Si les variables d'environnement sont absentes, `supabase` vaut `null` :
 *   l'application demarre quand meme et affiche un bandeau de configuration.
 *   Utiliser `requireSupabase()` dans le code qui ne peut pas fonctionner sans.
 */
export type TypedSupabaseClient = SupabaseClient<Database>;

export const supabase: TypedSupabaseClient | null = isSupabaseConfigured
  ? createClient<Database>(env.supabaseUrl, env.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
      },
      global: {
        headers: { 'x-application-name': 'carflow-web' },
      },
    })
  : null;

export function requireSupabase(): TypedSupabaseClient {
  if (!supabase) {
    throw new Error(
      'Supabase n’est pas configuré. Renseignez VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY dans .env.local.',
    );
  }
  return supabase;
}

export { isSupabaseConfigured };
